import React from 'react';
import type { ComponentProps } from 'react';
import { Custom as CustomOriginal } from '../../Custom';
import { LazyCustomHoneymoon } from './CustomHoneymoon.lazy';
import { useIsStaysRedesignActive } from './useIsStaysRedesignActive';

type Props = ComponentProps<typeof CustomOriginal>;

/**
 * Dispatcher for the stays-page redesign experiment. Renders the honeymoon
 * variant only when the current event is a redesign target; otherwise falls
 * through to the untouched develop implementation.
 */
export const Custom: React.FC<Props> = props => {
  const isRedesignActive = useIsStaysRedesignActive();
  return isRedesignActive ? <LazyCustomHoneymoon {...props} /> : <CustomOriginal {...props} />;
};
